import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { GridColDef } from "@mui/x-data-grid";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import {
  NewUserProfile,
  NewUserRole,
} from "../../../../store/newProfile/types";
import { RequestStatus } from "../../../Enum";

interface BusinessActivityColumnsProps {
  profile: NewUserProfile;
  profileRole: NewUserRole;
}

export function BusinessActivityColumns({
  profile,
  profileRole,
}: BusinessActivityColumnsProps): GridColDef[] {
  return [
    {
      field: "action",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderHeader: () => <b>Action</b>,
      renderCell: (params) => {
        if (
          profileRole.roleId === "RL240000001" &&
          (params.row.requestStatus === RequestStatus.Draft ||
            params.row.requestStatus === RequestStatus.Pending) &&
          params.row.binusianID === profile.BinusianId
        ) {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Link
                to={`/edit/${params.row.requestID}`}
                style={{ width: "30px" }}
              >
                <EditOutlinedIcon className="pencilAction" />
              </Link>

              <Link
                to={`/view/${params.row.requestID}`}
                style={{ width: "30px" }}
              >
                <SearchOutlinedIcon className="black" />
              </Link>
            </div>
          );
        }

        if (profileRole.roleId === "RL240000001") {
          return (
            <Link to={`/view/${params.row.requestID}`}>
              <SearchOutlinedIcon className="black" />
            </Link>
          );
        }

        return "";
      },
    },
    {
      field: "requestStatus",
      width: 150,
      renderHeader: () => <b>Request Status</b>,
      renderCell: (params) => {
        if (
          profileRole.roleId === "RL240000001" &&
          (params.row.requestStatus === RequestStatus.Draft ||
            params.row.requestStatus === RequestStatus.Pending) &&
          params.row.binusianID === profile.BinusianId
        ) {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Link
                style={{ color: "#6C2882" }}
                to={`/edit/${params.row.requestID}`}
              >
                {params.row.requestStatus}
              </Link>
            </div>
          );
        }

        if (profileRole.roleId === "RL240000001") {
          return (
            <Link
              style={{ color: "#6C2882" }}
              to={`/view/${params.row.requestID}`}
            >
              {params.row.requestStatus}
            </Link>
          );
        }

        return "";
      },
    },
    {
      field: "requestNumber",
      width: 220,
      renderHeader: () => <b>Request No.</b>,
    },
    {
      field: "requestDate",
      width: 180,
      renderHeader: () => <b>Request Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.requestDate}</Moment>
        </div>
      ),
    },
    { field: "noCRR", width: 170, renderHeader: () => <b>CRR No.</b> },
    {
      field: "counterpart",
      width: 250,
      renderHeader: () => <b>Counterpart</b>,
      renderCell: (params) => <div>{params.row.counterpart}</div>,
    },
    {
      field: "requestType",
      width: 150,
      renderHeader: () => <b>Request Type</b>,
      renderCell: (params) => <div>{params.row.requestType}</div>,
    },
    {
      field: "documentType",
      width: 150,
      renderHeader: () => <b>Document Type</b>,
      renderCell: (params) => <div>{params.row.documentType}</div>,
    },
    {
      field: "noPOA",
      width: 250,
      renderHeader: () => <b>POA No.</b>,
      renderCell: (params) => (
        <div>
          {params.row.noPOA}
          <br />
          {params.row.noSubstitution}
        </div>
      ),
    },
  ];
}
